<template>
  <div>
    <!-- PC端固定悬浮 -->
    <div id="Fixed">
      <dl @click="goTop">
        <dt><img src="/images/u495.svg" alt="回到顶部"/></dt>
      </dl>
      <dl>
        <dt><img src="/images/u491.svg" alt="电话"/></dt>
        <dd>
          <h2>{{ settings.contactNumber }}</h2>
          <img src="/images/RightArr.png" alt="箭头"/>
        </dd>
      </dl>
      <dl>
        <dt><img src="/images/u492.svg" alt="微信"/></dt>
        <dd>
          <h2><img :src="settings.wechatKefuQrCode" alt="客服"/>
          </h2>
        </dd>
      </dl>
      <dl>
        <dt><img src="/images/u493.svg" alt="微信"/></dt>
        <dd>
          <h2><img :src="settings.wechatQrCode" alt="公众号二维码"/>
            <p>微信公众号</p>
          </h2>
          <img src="/images/RightArr.png" alt="箭头" class="RightArr"/>
        </dd>
      </dl>
    </div>

  </div>
</template>

<script>

import { getSetting } from '@/api/request';

export default {
  name: 'FloatingContact',
  data() {
    return {
      settings: {
        contactNumber: '',
        wechatKefuQrCode: '',
        wechatQrCode: ''
      }
    };
  },
  methods: {
    fetchSettings() {
      getSetting().then(response => {
        const settingsData = response.list;
        this.settings.contactNumber = this.findSetting(settingsData, '联系方式').value_string;
        this.settings.wechatQrCode = this.findSetting(settingsData, '微信小程序二维码').value_url[0];
        this.settings.wechatKefuQrCode = this.findSetting(settingsData, '微信客服二维码').value_url[0];
      });
    },
    findSetting(settings, name) {
      return settings.find(setting => setting.name === name) || {};
    },
    goTop() {
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    scrollToBottom() {
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      window.scrollTo({
        top: scrollHeight - clientHeight,
        behavior: 'smooth',
      });
    }
  },
  mounted() {
    this.fetchSettings();
  }
};
</script>

<style scoped>
/* PC端侧边栏样式 */
#Fixed {
  background: #47975a;
  position: fixed;
  top: 40%;
  right: 10px;
  z-index: 999;
  border-radius: 5px;
}

#Fixed dl {
  cursor: pointer;
  text-align: center;
  padding: 10px;
  border-bottom: 1px solid #47975a;
  width: 40px;
  position: relative;
}

#Fixed dl:last-child {
  border: none;
}

#Fixed dl dt img {
  width: 15px;
}

#Fixed dl dd {
  display: none;
  position: absolute;
  right: 50px;
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  padding: 10px 15px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
}

#Fixed dl:hover dd {
  display: block;
}

#Fixed dl dd h2 {
  font-size: 15px;
  color: #47975a;
  margin: 0;
}

/* 移动端底部固定导航样式 */
#WapFixed {
  display: none;
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 999;
}

#WapFixed dl {
  position: relative;
  margin-bottom: 10px;
}

#WapFixed dl dt {
  cursor: pointer;
}

/* 确保弹出框在视口中可见 */
.phone-popup,
.wechat-popup {
  box-sizing: border-box;
  min-width: 120px;
}

/* 针对小屏幕的适配 */
@media (max-width: 768px) {
  .phone-popup,
  .wechat-popup {
    right: 50px;
    min-width: 100px;
  }

  .wechat-popup h2 img {
    width: 80px !important;
    height: 80px !important;
  }
}

/* 响应式设计 */
@media screen and (max-width: 48rem) {
  #Fixed {
    display: none;
  }

  #WapFixed {
    display: block;
    position: fixed;
    bottom: 4.375rem;
    right: 0.625rem;
    flex-direction: column;
    gap: 0.5rem;
    z-index: 1000;
  }

  #WapFixed dl {
    width: 2.25rem;
    height: 2.25rem;
    background: #47975a;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  #WapFixed dl dt img {
    width: 1.25rem;
    height: 1.25rem;
  }
}

/* 在移动端隐藏 */
@media screen and (max-width: 768px) {
  #Fixed {
    display: none;
  }
}
</style>